import React from "react";
import { Navigate } from "react-router-dom";
const studentGuard = (Element) => {
  return (props) => {
    localStorage.getItem("xAuthToken");
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (user.role === "STUDENT") {
      return <Element {...props} />;
    } else {
      return <Navigate to="/dashboard" />;
    }
  };
};

export default studentGuard;
